import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=72531bb5&scoped=true&"
import script from "./LegalInfo.vue?vue&type=script&lang=js&"
export * from "./LegalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=72531bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72531bb5",
  null
  
)

export default component.exports